/**
 * Add timeout functionality to drop downs
 *
 * If the user clicks the label the dropdown will show.
 * If the user is NOT hovering the dropdown a timer will start, after 1 seconds the dropdown will hide
 * If the user hovers the dropdown within the 1 seconds the timer will reset
 */

let drops = Array.from(document.querySelectorAll('.dropdown'))

if(drops.length > 0) {

    drops.forEach( dropdown => {
        let input = dropdown.previousElementSibling
        let timer

        dropdown.addEventListener('mouseenter', () => {
            clearTimeout(timer)
        })

        dropdown.addEventListener('mouseleave', () => {
            timer = setTimeout(() => {
                input.checked = false
            }, 1000)
        })
    })
}
